import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { Title, Breadcrumb, PopUpModal, CustomPopUpModal, LoaderModal, } from "../../Components/Atoms";
import { Button, Spinner, Switch, useToast } from "@chakra-ui/react";
import PATH from "../../Routes/paths";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { TickIcon, VideoIcon, ChevronRightIcon, LockIcon, UnlockIcon, } from "../../Assets/images/svgs";
import { getPingTestStatus, getSpecificDevDetails, saveRelayTestStatus } from "../../APIs";
import { DEVICE_TYPES_VALS, PING_TEST_STATUS, PING_TEST_STATUS_VAL, RELAY_STATES, SELLER_DES, SPN_IDS, SUBDEALERS_DES } from "../../Library/constants";
import { getLocalisedDate } from "../../Library/datetime";
import PATHS from "../../Routes/paths";
import LastOrder from "../../Widgets/LastOrder";

const SpecificDevice = () => {
  const navigate = useNavigate();

  const [ popUpModal, setPopUpModal ] = useState(null);
  const [customModal, setCustomModal] = useState(null);
  const [loaderModal, setLoaderModal] = useState(false);
  const loaderModalRef = useRef(false);
  const [ devAndVehicleDetails, setDevAndVehicleDetails ] = useState({});
  const[ isPingTestSuccess, setIsPingTestSuccess ] = useState(false);
  const[ relayTestStarted, setRelayTestStarted ] = useState(false);
  const [ pingOrRelayTestError, setPingOrRelayTestError ] = useState("");
  const [ relayState, setRelayTest ] = useState(0);
  const [ relayLoading, setRelayLoading ] = useState(false);
  const [ relayError, setRelayError ] = useState("");
  const [ wsConnected, setWsConnected ] = useState(false);

  const [ searchParams ] = useSearchParams();
  const ImeiRef = useRef(searchParams.get("imei"));
  const dealerId = useRef(searchParams.get("idx"));
  const instock = useRef(searchParams.get("stock"));
  const installed = useRef(searchParams.get("installed"));
  const isRelayLoading = useRef(false);

  const devAndVehDetails = useRef({});
  const currentStateRef = useRef(-1);
  const isRelayTest = useRef(false);
  const pingTestTimeout = useRef(null);
  const onLoadPingTestSuccess = useRef(false);
  const checkRelayStatusSuccess = useRef(false);

  const RELAY_TEST_STEPS_MAP = useRef({});

  const Toast = useToast();

  const DESIGNATION = JSON.parse(window.localStorage.getItem("des"));
  let SHOW_RELAY_TEST_BTN = window.localStorage.getItem("relay");
  if (SHOW_RELAY_TEST_BTN) {
    try {
      SHOW_RELAY_TEST_BTN = JSON.parse(SHOW_RELAY_TEST_BTN);
    } catch (e){
      if (e) SHOW_RELAY_TEST_BTN = false;
    }
  }

  const getLink = () => {
    if (DESIGNATION === SUBDEALERS_DES) {
      return PATH.INVENTORY_OVERVIEW;
    }
    else {
      let url = `${PATH.SHOW_DEALERS}/${PATH.DEVICES}?idx=${dealerId.current}`
      if (instock.current) url += `&inStock=true`;
      if (installed.current) url += `&installed=true`;
      return url;
    }
  }

  const paths = [
    { idx: 1, name: DESIGNATION === SUBDEALERS_DES ? "Inventory Management" : "Devices", link: getLink() },
    { idx: 2, name: "Device Details", isCurrentPage: true },
  ];

  const handlePingTestSuccess = (data, success) => {
    const isSuccess = Boolean(success || (data && (data.imei || data.voltLvl || data.ts)));
    if (!isSuccess) {
      setPingOrRelayTestError(`${data}. Please try again later`);
      setTimeout(() => {
        setLoaderModal(false);
        loaderModalRef.current = false;
      }, 5000);

      return;
    }

    if (!loaderModalRef.current && isSuccess) {
      onLoadPingTestSuccess.current = true;
      return;
    }

    if (!isRelayTest.current) {
      clearTimeout(pingTestTimeout.current);
      setLoaderModal(false);
      loaderModalRef.current = false;

      // if (isSuccess && global.WS && global.WS.wsConnected) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.UNSUBSCRIBE_FROM_WIRELESS_TESTING, data: { imei: ImeiRef.current } });
      setIsPingTestSuccess(isSuccess);
      const modalData = {
          open: true,
          closeBtn: isSuccess ? "Okay" : "Close",
          onModalClose: () => setCustomModal(null),
          modalBody: (
              <div className="ping-test-result">
                <p>{isSuccess ? "Ping Test Completed Successfully" : "Ping test is taking a bit longer than expected"}</p>
              </div>
          ),
      };
      setCustomModal(modalData);
      setDevAndVehicleDetails({ ...devAndVehDetails.current, ptStat: { st: PING_TEST_STATUS_VAL["Tested"], ts: Date.now() }, installationDetails: { ...devAndVehDetails.installationDetails, ptStat: PING_TEST_STATUS_VAL["Tested"], ptTs: Date.now() } });
    } else {
      getRelayState();
    }
  };

  const handleLockUnlockTest = (currentState) => {
    setLoaderModal(true);
    loaderModalRef.current = true;
    setCustomModal(null);
    if (global.WS) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.LITE_CMD_RESP , data: { imei: ImeiRef.current, command: `RELAY,${currentState ? RELAY_STATES.UNLOCKED : RELAY_STATES.LOCKED}#`} });
  }

  const unsubscribeAndCloseModal = (relayState) => {
    saveRelayTestStatus({ imei: ImeiRef.current, rlyResp: relayState ? RELAY_STATES.LOCKED : RELAY_STATES.UNLOCKED }, (err) => {
      if (err) console.error(err);
      else setDevAndVehicleDetails({ ...devAndVehDetails.current, installationDetails: { ...devAndVehDetails.installationDetails, relayStat: relayState ? RELAY_STATES.UNLOCKED : RELAY_STATES.LOCKED, relayTs: Date.now() } });
    });

    // if (global.WS) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.UNSUBSCRIBE_FROM_WIRELESS_TESTING, data: { imei: ImeiRef.current } });
    setCustomModal(null);
  }

  const handleRelayToggle = (state, unlock) => {
    if ((state && unlock) || (!state && !unlock)) handleLockUnlockTest(state);
  };

  const requestRelayToggle = (currentState) => {
    setPopUpModal({ open: false })
    setCustomModal({
      open: true,
      modalBody: (
        <div>
          <Spinner size={"lg"} />
          <p className="relay-modal-message">This vehicle is getting {currentState ? "Unlocked" : "Locked"}</p>
          <p className="relay-modal-note">It might take upto 10 sec</p>
        </div>
      ),
      onModalClose: () => {},
    });

    if (global.WS) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.LITE_CMD_RESP , data: { imei: ImeiRef.current, isMapped: !!devAndVehDetails.current.dm, command: `RELAY,${currentState ? RELAY_STATES.UNLOCKED : RELAY_STATES.LOCKED}#`} });
  }

  const handleConfirmModal = (state) => {
    setPopUpModal({
      open: true,
      modalMsg: <p className="relay-confirm-msg">Are you sure you want to lock this vehicle ?</p>,
      onModalClose: () => setPopUpModal(null),
      closeBtn: "Cancel",
      confirmBtn: state ? "Unlock" : "Lock",
      onConfirm: () => requestRelayToggle(state),
      footer: "relay-confirm-modal",
    });
  }

  const renderRelayButton = (currentState, updateClasses, showConfirmModal) => {
    if (!currentState) currentState = relayState;
    return (
      <div className={`relay-current-state-modal ${(currentState) ? "fill-lock-icon" : "fill-unlock-icon"} ${updateClasses ? "shrink-component" : ""}`}>
        {!updateClasses ? <p>Current status: {(currentState) ? "Locked" : "Unlocked"}</p> : null}
        <div className={`toggle-container ${(currentState) ? " locked" : " unlocked"} ${updateClasses ? "remove-margin" : ""}`}>
          <div className={!(currentState) ? "active-unlock" : "inactive-icon"}>
            <UnlockIcon className="cursor-pointer" onClick={() => handleRelayToggle((currentState), true)} />
            <h2>Unlock</h2>
          </div>
          <Switch size='lg' isChecked={(currentState)} onChange={() => showConfirmModal ? handleConfirmModal((currentState)) : handleLockUnlockTest((currentState))} className={(currentState) ? "toggle-lock" : "toggle-unlock"} />
          <div className={(currentState) ? "active-lock" : "inactive-icon"}>
            <LockIcon className="cursor-pointer" onClick={() => handleRelayToggle((currentState))} />
            <h2>Lock</h2>
          </div>
        </div>
      </div>
    );
  }

  const onLiteCmdResp = (resp) => {
    if (!RELAY_TEST_STEPS_MAP.current["count"]) RELAY_TEST_STEPS_MAP.current["count"] = 1;
    else RELAY_TEST_STEPS_MAP.current["count"] += 1;

    if(!resp) return;
    let currentState = false;

    if(resp.includes('RELAY:')) {
      var relayState = parseInt(resp.split(':')[1]);
      currentStateRef.current = !!relayState;
      currentState = !!relayState;
      setRelayTest(relayState);

      if (isRelayLoading.current) {
        global.WS.sendRequest({ action: global.EE.EVENT_TYPES.SET_CURRENT_RLS, data: { imei: ImeiRef.current, rls: relayState } });
        isRelayLoading.current = false;
        setRelayLoading(false);
        setRelayTest(currentState);
        return;
      }

      RELAY_TEST_STEPS_MAP.current["state"] = relayState ? 1 : 0;
      RELAY_TEST_STEPS_MAP.current["button"] = relayState ? "Test Unlocking" : "Test Locking";
      if (global.WS) RELAY_TEST_STEPS_MAP.current["onClick"] = () => handleLockUnlockTest(relayState ? true : false);
      if (RELAY_TEST_STEPS_MAP.current["count"] === 1) RELAY_TEST_STEPS_MAP.current[relayState ? "isInitialStateLocked" : "isInitialStateUnlocked"] = true;
    }
    else if(resp.includes('Cut off the fuel supply: Success!') || resp.includes("Already in the state of of fuel supply cut off, the command is not running!")) {
      currentStateRef.current = true;
      currentState = true;
      setRelayTest(RELAY_STATES.LOCKED);

      RELAY_TEST_STEPS_MAP.current["state"] = 1;
      RELAY_TEST_STEPS_MAP.current["button"] = "Test Unlocking";
      if (global.WS) RELAY_TEST_STEPS_MAP.current["onClick"] = () => handleLockUnlockTest(true);
      if (RELAY_TEST_STEPS_MAP.current["count"] === 1) RELAY_TEST_STEPS_MAP.current["isInitialStateLocked"] = true;
    }
    else if(resp.includes('Restore fuel supply: Success!') || resp.includes("Already in the state of fuel supply to resume, the command is not running!")) {
      currentStateRef.current = false;
      currentState = false;
      setRelayTest(RELAY_STATES.UNLOCKED);

      RELAY_TEST_STEPS_MAP.current["state"] = 0;
      RELAY_TEST_STEPS_MAP.current["button"] = "Test Locking";
      if (global.WS) RELAY_TEST_STEPS_MAP.current["onClick"] = () => handleLockUnlockTest(false);
      if (RELAY_TEST_STEPS_MAP.current["count"] === 1) RELAY_TEST_STEPS_MAP.current["isInitialStateUnlocked"] = true;
    } else {
      if (isRelayLoading.current) {
        setRelayLoading(false);
        isRelayLoading.current = false;
        setRelayError(resp);
      }
      setPingOrRelayTestError(resp);

      setCustomModal({
        open: true,
        modalBody: (
          <p className="loader-error-msg">{resp}</p>
        ),
        closeBtn: "Okay",
        onModalClose: () => setCustomModal({ open: false }),
      });
      return;
    }

    const isTestComplete = (
      (RELAY_TEST_STEPS_MAP.current["isInitialStateLocked"] && RELAY_TEST_STEPS_MAP.current["count"] === 2) ||
      (RELAY_TEST_STEPS_MAP.current["isInitialStateUnlocked"])
    );

    if (isTestComplete && RELAY_TEST_STEPS_MAP.current["state"] === RELAY_STATES.UNLOCKED && RELAY_TEST_STEPS_MAP.current["count"] > 1) {
      RELAY_TEST_STEPS_MAP.current["button"] = "Mark test complete";
      RELAY_TEST_STEPS_MAP.current["onClick"] = () => unsubscribeAndCloseModal(currentStateRef.current);
    }

    setLoaderModal(false);
    loaderModalRef.current = false;
    if (devAndVehDetails.current && devAndVehDetails.current.dm) {
      setCustomModal({
        open: true,
        startBtn: "Okay",
        onStart: () => setCustomModal({ open: false }),
        onModalClose: () => {},
        modalBody: (
          <div className={`lock-unlock-success-modal ${currentState ? "locked" : "unlocked"}`}>
            {currentState ? <LockIcon /> : <UnlockIcon />}
            <p className="lock-unlock-success-msg">This vehicle is now {currentState ? "locked" : "unlocked"}</p>
          </div>
        ),
      });
    } else {
      setCustomModal({
        open: true,
        startBtn: RELAY_TEST_STEPS_MAP.current["button"],
        onStart: RELAY_TEST_STEPS_MAP.current["onClick"],
        onModalClose: () => {},
        modalBody: renderRelayButton(currentState),
      });
    }
  }

  const SubscribeForTest = (src) => {
    if (global.WS && global.WS.wsConnected){
      global.WS.sendRequest({ action: global.EE.EVENT_TYPES.UNSUBSCRIBE_FROM_WIRELESS_TESTING, data: { imei: ImeiRef.current, d: "onWsConnected" } });
      global.WS.sendRequest({ action: global.EE.EVENT_TYPES.SUBSCRIBE_FOR_WIRELESS_TESTING, data: { imei: ImeiRef.current, d: src } });
    }
  }

  const checkRelayStatus = () => {
    if (!SHOW_RELAY_TEST_BTN || checkRelayStatusSuccess.current) return;

    checkRelayStatusSuccess.current = true;
    global.WS.sendRequest({ action: global.EE.EVENT_TYPES.LITE_CMD_RESP , data: { imei: ImeiRef.current, command: "RELAY#" } });
    setRelayLoading(true);
    isRelayLoading.current = true;
  }

  useEffect(() => {
    if (devAndVehicleDetails && devAndVehicleDetails.imei && wsConnected) {
      if (devAndVehicleDetails.dm && !(devAndVehicleDetails.rls || devAndVehicleDetails.rls == 0)) checkRelayStatus();
      if (!devAndVehicleDetails.dm) SubscribeForTest('onWsConnected');
    }

  }, [ devAndVehicleDetails, wsConnected ])

  useEffect(() => {
    global.EE.addEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, onWsConnected);
    getSpecificDevDetails(ImeiRef.current, (err, data) => {
      if (err) console.error(err);
      else {
        data = data[0];
        if (!data) data = {};
        data.vnm = "Ajjas";
        if (data.deliveredAt) data.deliveredTs = getLocalisedDate(data.deliveredAt, true);
        devAndVehDetails.current = data;

        data.installationDetails = {};
        if (data.instTs) data.installationDetails.instTs = data.instTs;
        if (data.ptStat) {
          data.installationDetails.ptStat = data.ptStat.st;
          data.installationDetails.ptTs = data.ptStat.ts;
        }
        if (data.rlyResp || data.rlyResp === 0) data.installationDetails.relayStat = data.rlyResp;
        if (data.rlyRespTs) data.installationDetails.relayTs = data.rlyRespTs;
        if (data.dm) {
          data.mappingTs = getLocalisedDate(data.dm, true);
          data.installationDetails.mapTs = data.dm;
        }
        else SubscribeForTest('api_resp');
        if (data.rls || data.rls == 0) setRelayTest(!!data.rls);
        else {
          if (global.WS && global.WS.wsConnected && !wsConnected) checkRelayStatus();
        }

        setDevAndVehicleDetails(data);
      }
    });

    global.EE.addEventListener(global.EE.EVENT_TYPES.WIRELESS_TESTING_SUCCESSFULL, handlePingTestSuccess);
    global.EE.addEventListener(global.EE.EVENT_TYPES.LITE_CMD_RESP, onLiteCmdResp);

    const onUnload = () => {
      if (global.WS && global.WS.wsConnected) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.UNSUBSCRIBE_FROM_WIRELESS_TESTING, data: { imei: ImeiRef.current, d: "onunload" } });
      global.EE.removeEventListener(global.EE.EVENT_TYPES.WS_CONNECTED, onWsConnected);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.WIRELESS_TESTING_SUCCESSFULL, handlePingTestSuccess);
      global.EE.removeEventListener(global.EE.EVENT_TYPES.LITE_CMD_RESP, onLiteCmdResp);
    };

    window.onbeforeunload = function(e) {
      return onUnload();
    };

    return () => {
      onUnload();
    };
  }, []);

  const onWsConnected = () =>{
    setWsConnected(true);
  }

  // const handleReqRepClick = () => {
  //   setPopUpModal({
  //     open: true,
  //     modalMsg: "Are you sure you want to request replacement for this device?",
  //     closeBtn: "Cancel",
  //     onModalClose: () => setPopUpModal({ isOpen: false }),
  //     confirmBtn: "Request Replacement",
  //     onConfirm: () => {
  //       setPopUpModal({
  //         open: true,
  //         modalMsg: "Replacement Requested Successfully",
  //         onModalClose: () => setPopUpModal(null),
  //       });
  //       setTimeout(() => {
  //         setPopUpModal({ isOpen: false });
  //       }, 2000);
  //     },
  //   });
  // };

  const handlePerformPingTest = () => {
    if (!((!devAndVehicleDetails.ptStat || (devAndVehicleDetails.ptStat && devAndVehicleDetails.ptStat.st !== PING_TEST_STATUS_VAL["Tested"])) && !isPingTestSuccess)) return;

    if (onLoadPingTestSuccess.current) {
      const modalData = {
        open: true,
        closeBtn: "Okay",
        onModalClose: () => {setCustomModal(null); setIsPingTestSuccess(true); setDevAndVehicleDetails({ ...devAndVehDetails.current, ptStat: { st: PING_TEST_STATUS_VAL["Tested"], ts: Date.now() }, installationDetails: { ...devAndVehDetails.installationDetails, ptStat: PING_TEST_STATUS_VAL["Tested"], ptTs: Date.now() } });},
        modalBody: (
            <div className="ping-test-result">
              <p>{"Ping Test Completed Successfully"}</p>
            </div>
        ),
      };

      setCustomModal(modalData);
      return;
    }

    setCustomModal({
      open: true,
      modalTitle: "How To Perform The Ping Test",
      modalBody: (
        <div className="ping-test-body">
          <p>
            <TickIcon />
            <span>Make sure you are in a good network area</span>
          </p>
          {/* <p>
            <TickIcon />
            <span>Turn ON the ignition & start the mapped vehicle</span>
          </p> */}
          <p>
            <VideoIcon />
            <Link className="v-link" to={`${PATHS.INSTALLATION_VIDEO}`}>Watch The Installation Video </Link>
            <ChevronRightIcon />
          </p>
        </div>
      ),
      onModalClose: () => setCustomModal(null),
      startBtn: "Start Ping Test",
      onStart: () => {
        setCustomModal(null);
        setLoaderModal(true);
        loaderModalRef.current = true;
        if (onLoadPingTestSuccess.current) {
          getPingTestStatus(ImeiRef.current, (err, data) => {});
          handlePingTestSuccess({}, true);
        }
      },
    });
    pingTestTimeout.current = setTimeout(() => {
      setCustomModal(null);
      setLoaderModal(false);
      loaderModalRef.current = false;

      isPingTestSuccess ?
      setCustomModal({
        open: true,
        closeBtn: "Okay",
        onModalClose: () => setCustomModal(null),
        modalBody: (
          <div className="ping-test-result">
            <p>Ping Test Completed Successfully</p>
          </div>
        ),
      }) :
      setCustomModal({
        open: true,
        closeBtn: "Close",
        onModalClose: () => setCustomModal(null),
        modalBody: (
          <div className="ping-test-result">
            <p>Ping test is taking a bit longer than expected</p>
          </div>
        ),
      })

    }, (1000 * 60) * 5);
  };

  const devDetailsKeyValues = [
    { label: "IMEI", key: "imei" },
    { label: "Order ID", key: "orderId" },
    { label: "Device Type", key: "btrId", constants: DEVICE_TYPES_VALS, constantsAccessor: "nm" },
    { label: "Delivery Date", key: "deliveredTs" },
    { label: "Mapping Status", key: "dm", condition: true },
    { label: "SIM", key: "spnId", constants: SPN_IDS, constantsAccessor: "nm" },
    { label: "Vendor Name", key: "vnm" },
    { label: "Ping Test Status", key: "ptStat", nestedKey: "st", constants: PING_TEST_STATUS },
  ];

  const vehDetailsKeyValues = [
    { label: "Chassis Number", key: "chNum" },
    { label: "Internal ID", key: "reg" },
    { label: "Mapping Date", key: "mappingTs" },
  ]

  const getValue = (detail, devAndVehicleDetails) => {
    if (detail.condition) return devAndVehicleDetails[detail.key] ? "Mapped" : "Unmapped";
    if (detail.constants) {
      let value = (detail.nestedKey && devAndVehicleDetails[detail.key]) ? (devAndVehicleDetails[detail.key])[detail.nestedKey] : devAndVehicleDetails[detail.key];
      const constantDetail = detail.constants[value];
      return (constantDetail && constantDetail[detail.constantsAccessor]) ? constantDetail[detail.constantsAccessor] : (constantDetail || "-");
    }

    return devAndVehicleDetails[detail.key];
  };

  const handlePingTestResponse = (isPingTestSuccessful) => {
    if (isPingTestSuccessful) {
      handlePingTestSuccess(null, isPingTestSuccessful);
    } else {
      if (global.WS) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.SUBSCRIBE_FOR_WIRELESS_TESTING, data: { imei: ImeiRef.current } });
    }
  }

  const handleLoaderModalClose = () => {
    // if (global.WS && global.WS.wsConnected) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.UNSUBSCRIBE_FROM_WIRELESS_TESTING, data: { imei: ImeiRef.current } });

    let data = {
      open: true,
      closeBtn: "Close",
      onModalClose: () => setCustomModal(null),
      modalBody: (
        <div className="ping-test-result">
          <p>Cancelled Successfully</p>
        </div>
      ),
    };
    setLoaderModal(false);
    loaderModalRef.current = false;
    if (!pingOrRelayTestError) setCustomModal(data);
    else setPingOrRelayTestError("");
  }

  const handlePingTestErr = () => {
    setLoaderModal(false);
    loaderModalRef.current = false;

    const modalData = {
        open: true,
        closeBtn: "Close",
        onModalClose: () => setCustomModal(null),
        modalBody: (
            <div className="ping-test-result">
              <p>{"Something went wrong, please try again later!"}</p>
            </div>
        ),
    };
    setCustomModal(modalData);
  }

  const getRelayState = () => {
    if(currentStateRef.current === -1) {
      if (global.WS) global.WS.sendRequest({ action: global.EE.EVENT_TYPES.LITE_CMD_RESP , data: { imei: ImeiRef.current, command: "RELAY#" } });
    }
  }

  const checkIfPingTestIsCompleted = () => {
    if (DESIGNATION === SELLER_DES) return;

    if (!devAndVehicleDetails.ptStat || !devAndVehicleDetails.ptStat.st || devAndVehicleDetails.ptStat.st !== PING_TEST_STATUS_VAL["Tested"]) {
      Toast({ isClosable: true, description: "Complete ping test to perform relay test", position: "bottom", variant: "subtle", duration: 3000 })
    } else {
      setLoaderModal(true);
      loaderModalRef.current = true;
      setRelayTestStarted(true);
      loaderModalRef.current = true;
      isRelayTest.current = true;

      if (global.WS) global.WS.sendRequest({ action:  global.EE.EVENT_TYPES.LITE_CMD_RESP, data: { imei: ImeiRef.current, command: devAndVehicleDetails.rlyResp ? `RELAY,${devAndVehicleDetails.rlyResp}#` : "RELAY#" } });
    }
  }

  const handleMapDevice = () => {
    if (!(devAndVehicleDetails && !devAndVehicleDetails.dm)) return;
    navigate(
      `${PATH.INVENTORY_OVERVIEW}/${PATH.MAP_TO_VEHICLE}?imei=${ImeiRef.current}`
    );
  }

  return (
    <div className="specific-order">
      <div className="breadcrumb-container">
        <Breadcrumb paths={paths} />
      </div>

      <div className="details-container">
        <div className="device-details detail">
          <div className="title-container">
            <Title>Device Details</Title>
            {DESIGNATION === SELLER_DES && (!devAndVehicleDetails.ptStat || devAndVehicleDetails.ptStat.st !== PING_TEST_STATUS_VAL["Tested"]) && <Button className="seller-ping-test-btn" onClick={handlePerformPingTest}>Perform Ping Test</Button>}
          </div>
          <div className="info">
            {devDetailsKeyValues.map(detail => (
              <p key={detail.key}>
                  <span className="key">{detail.label}:</span>
                  <span className="value">{getValue(detail, devAndVehicleDetails)}</span>
              </p>
            ))}
          </div>
        </div>
        {devAndVehicleDetails.dm && <div className="vehicle-details detail">
          <div className="title-container">
            <Title>Vehicle Details</Title>
            {(SHOW_RELAY_TEST_BTN && (DESIGNATION === SELLER_DES || DESIGNATION === SUBDEALERS_DES) && !relayLoading && !relayError) ? renderRelayButton(null, true, true) : (!relayError && SHOW_RELAY_TEST_BTN ? <Spinner /> : null)}
          </div>
          <div className="info vehicle-details">
            { vehDetailsKeyValues.map(detail => (
              <p key={detail.key}>
                <span className="key">{detail.label}:</span>
                <span className="value">{devAndVehicleDetails[detail.key] || "-"}</span>
              </p>
            )) }
          </div>
        </div>}
      </div>

      <div className="installation-detail-container">
        <LastOrder
          showOrderDetails={false}
          isOverviewPage={false}
          isInstallationDetails={true}
          installationDetails={devAndVehicleDetails.installationDetails}
          handleMapDevice={handleMapDevice}
          checkIfPingTestIsCompleted={checkIfPingTestIsCompleted}
          handlePerformPingTest={handlePerformPingTest}
        />
      </div>

      <PopUpModal {...popUpModal} />
      <CustomPopUpModal {...customModal} />
      <LoaderModal
        show={loaderModal}
        onModalClose={() => {}}
        imei={ImeiRef.current}
        onPingTestResponse={handlePingTestResponse}
        handleLoaderModalClose={handleLoaderModalClose}
        handlePingTestErr={handlePingTestErr}
        relayTestStarted={relayTestStarted}
        errMsg={pingOrRelayTestError}
      />
    </div>
  );
};

export default SpecificDevice;
